import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgTrendingSolid = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 23 37"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M8.295.262a1.85 1.85 0 0 1 1.84-.033c8.3 3.855 12.999 11.862 12.71 18.557-.125 2.812-1.13 5.417-3.082 7.317-1.952 1.903-4.757 3.015-8.306 3.021A10.794 10.794 0 0 1 .003 18.784v-.017a9.12 9.12 0 0 1 4.686-8.202 1.04 1.04 0 0 1 1.457.489 10.4 10.4 0 0 0 2.097 3.094C9.27 12.805 9.746 11.07 9.73 9.164c-.016-2.27-.728-4.703-1.923-6.774A1.58 1.58 0 0 1 8.295.262"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        d="M21.555 31.135c-3.164 1.177-6.43 1.89-9.719 1.895-3.287-.005-6.554-.718-9.718-1.896-.216-.08-.375.197-.218.39 1.912 2.279 4.49 3.678 7.15 4.282.918.206 1.852.31 2.787.314.935-.004 1.87-.108 2.787-.314 2.66-.604 5.238-2.003 7.15-4.281.157-.194-.002-.471-.218-.39"
      />
    </svg>
  );
};
export default SvgTrendingSolid;
